import { backendClient } from "./clients";

const COMPANY_USAGE_CACHE_TTL_MS = 60 * 1000;
const companyUsageRequests = new Map();

const getCompanyUsageRequestKey = (companies = []) => {
  return [...companies].filter(Boolean).sort().join("|");
};

export function createUserConfigExport(company, user, exportConfiguration) {
  return backendClient
    .request({
      url: "/CreateUserConfiguration",
      method: "post",
      data: {
        company,
        exportConfiguration,
        user,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export function getUserExport(company, user) {
  return backendClient
    .request({
      url: "/GetUserConfiguration",
      method: "post",
      data: { company, user },
    })
    .then((res) => res.data)
    .catch((err) => {
      // Gestionează eroarea aici
      console.error("Eroare în request:", err.message);
      // Returnăm un răspuns gol pentru a preveni propagarea erorii
      return null;
    });
}

export function removeUserExport(exportId, userId) {
  return backendClient
    .request({
      url: "/RemoveUserConfiguration",
      method: "post",
      data: {
        exportId,
        userId,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export async function GetCompanyUsagesByIds(companies) {
  const requestKey = getCompanyUsageRequestKey(companies);
  if (!requestKey) return [];

  const cachedRequest = companyUsageRequests.get(requestKey);
  const now = Date.now();

  if (
    cachedRequest &&
    now - cachedRequest.timestamp < COMPANY_USAGE_CACHE_TTL_MS
  ) {
    return cachedRequest.promise;
  }

  const requestPromise = backendClient
    .request({
      url: "GetCompaniesConsumptionsStatus",
      method: "post",
      data: {
        companies,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error in GetUsersConsumptionsStatus:", err);
      throw err;
    });

  companyUsageRequests.set(requestKey, {
    promise: requestPromise,
    timestamp: now,
  });

  try {
    return await requestPromise;
  } catch (err) {
    throw err;
  }
}

export async function getNotificationPreferences() {
  try {
    const res = await backendClient.request({
      url: "GetNotificationPreferences",
      method: "post",
      timeout: 15000,
    });
    return res.data;
  } catch (err) {
    console.error("Error in GetNotificationPreferences:", err);
    throw err; // Re-throw the error to propagate it to the caller
  }
}

export async function updateNotificationPreferences(prefs = []) {
  try {
    const res = await backendClient.request({
      url: "UpdateNotificationPreferences",
      method: "post",
      timeout: 15000,
      data: prefs,
    });
    return res.data;
  } catch (err) {
    console.error("Error in UpdateNotificationPreferences:", err);
    throw err; // Re-throw the error to propagate it to the caller
  }
}
